import React, { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Card, Form, Icon, Image, Input, Message, Divider } from 'semantic-ui-react'
import Logo from '../images/logo-admin.png'
import { backendService } from '../services/backendService'
import {useHistory} from 'react-router-dom'
import { Text, Translate, LanguageContext } from '../helpers/language';

const Restore = (props) => {
  const languageContext = useContext(LanguageContext);
  const [ passwords, setPasswords ] = useState({
    newPassword: '',
    confirmedPassword: '',
  })
  const history = useHistory()
  const [error, setError] = useState(false)
  const [ message, setMessage ] = useState(null)
  const {id, token} = props.match.params
  const handleChange = (e) => {
    setPasswords({...passwords, [e.target.name]: e.target.value})
  }

  

  const handleSubmit = async () => {
    if (passwords.newPassword === passwords.confirmedPassword) {
      try {
        const response = await backendService.post(`/api/users/login/restore/${id}`, { token: token, password: passwords.newPassword});
        
        if( response.data.success === true ) {
          window.dataLayer.push({
            event: 'user_event',
            eventProps: {
              category: 'user_action',
              action: 'password_restored',
              label: 'User Password Restored',
              value: 'true'
          }
          });
          setMessage(Translate(languageContext, response.data.message))
        } else if (response.data.message) {
          window.dataLayer.push({
            event: 'user_event',
            eventProps: {
              category: 'user_action',
              action: 'password_restore_failed',
              label: 'User Password Restore Failed',
              value: 'false'
          }
          });
          setError(true)
          setMessage(Translate(languageContext, response.data.message))
        } 
      }
      catch(error){
        setError(true)
        setMessage(Translate(languageContext, 'generic_fail_message'))
      }
    }
    else {
      setError(true)
      setMessage(Translate(languageContext, 'passwords_dont_match'))
    }
    hideMessage();
  }
  
  const hideMessage = () => {
    setTimeout(() => {
      setMessage(null)
    }, 5000)
  }

  return (
    <div className="lisia-dialog lisia-centered-dialog">
          <Row center="xs">
            <Col className='lisia-restore-password-wrapper' xs={11} sm={9} md={7} lg={3}>
              <Card fluid={true} raised={true} centered={true}>
                <Card.Content>
                  <div className="loginForm">                    
                    <Image size='small' src={Logo} className='m-b-10 lisia-logo'/>
                    
                    <Form>
                      <h3 className='text-center'><Text tid='update_password' /></h3>
                      <Divider />
                      <Form.Field>
                        <label style={{float: 'left'}} ><Text tid='insert_new_password' /></label>
                        <Input type="password" value={passwords.newPassword} name="newPassword" onChange={handleChange} placeholder={Translate(languageContext,'insert_new_password')} />
                      </Form.Field>
                      <Form.Field>
                        <label style={{float: 'left'}} ><Text tid='confirm_new_password' /></label>
                        <Input type="password" value={passwords.confirmedPassword} name="confirmedPassword" onChange={handleChange} placeholder={Translate(languageContext,'repeat_new_password')} />
                      </Form.Field>
                      <Form.Field>
                          <Message hidden={!message} visible={message != null} icon>
                            <Icon name={error ? 'warning sign' : 'info sign'} />
                            <Message.Content>
                            { message }
                            </Message.Content>
                          </Message>
                      </Form.Field>        
                      <Button style={{width: '100%'}} type="submit" className='lisia-blue' onClick={handleSubmit} >
                        <Icon name='checkmark' /> <Text tid='change_password_button'/>
                      </Button>                      
                    </Form>
                    <Divider />  
                    <div className='footer'>       
                      <Link to='/login' style={{float: 'left'}}>
                        <Text tid="go_to_login" />
                      </Link>
                    </div>
                  </div>
                </Card.Content>
              </Card>
            </Col>
          </Row>        
    </div>
  )
}

Restore.propTypes = {

}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

export default connect(mapStateToProps)(Restore)